<script setup lang="ts" generic="TData">
import { FlexRender, type HeaderGroup } from '@tanstack/vue-table';

interface Props {
  footerGroups: HeaderGroup<TData>[];
}

defineProps<Props>();
</script>

<template>
  <tfoot
    v-if="footerGroups.some((group) => group.headers.some((header) => header.column.columnDef.footer))"
    class="base-table__tfoot"
  >
    <tr
      v-for="footerGroup in footerGroups"
      :key="footerGroup.id"
      class="base-table__footer-row"
    >
      <th
        v-for="footer in footerGroup.headers"
        :key="footer.id"
        :colspan="footer.colSpan"
        class="base-table__th"
      >
        <FlexRender
          :render="footer.column.columnDef.footer"
          :props="footer.getContext()"
        />
      </th>
    </tr>
  </tfoot>
</template>

<style scoped>
@reference "../../../../tailwind.css";

@layer components {
  .base-table__tfoot {
    background-color: var(--base-header-bg);
    color: var(--base-text-color);
    border-top: 1px solid var(--booking-chessboard-table-border-color);
  }

  .base-table__footer-row {
    border-top: 1px solid var(--booking-chessboard-table-border-color);
  }
}
</style>
